import {useParams, useLocation, useNavigate} from 'react-router'

type Params = {
  areaId?: string
}

export const useReplaceAreaIdParam = (areaRouteSegment: string) => {
  const {areaId: currentAreaId} = useParams<Params>()

  const location = useLocation()
  const navigate = useNavigate()

  return (newAreaId: string) => {
    if (!currentAreaId) {
      throw new Error('areaId is missing in the URL parameters')
    }
    const newPath = location.pathname.replace(
      `/${areaRouteSegment}/${currentAreaId}`,
      `/${areaRouteSegment}/${newAreaId}`
    )
    void navigate(`${newPath}${location.search}`)
  }
}
